const initialState = {
    list: [],
    add: {},
    edit: {},
    detail: {},
    count: 0,
    paging: {
        start: 0,
        limit: 10,
    }
};

export default function automaticConsumption(state = initialState, action) {
  switch(action.type) {
    case 'SET_AUTO_CONSUMPTION_COUNT': {
          return {
              ...state,
              count: action.count
          };
    }
    case 'SET_AUTO_CONSUMPTIONS': {
      return {
        ...state,
        list: action.autoConsumptions
      }
    }
    case 'SET_AUTO_CONSUMPTION': {
        return {
            ...state,
            detail: action.autoConsumption
        }
    }
    case 'SET_ADD_AUTO_CONSUMPTION': {
        return {
            ...state,
            add: action.data
        }
    }
    case 'SET_EDIT_AUTO_CONSUMPTION': {
        return {
            ...state,
            edit: action.data
        }
    }
    case 'SET_AUTO_CONSUMPTIONS_PAGING': {
        return {
            ...state,
            paging: action.paging
        }
    }
    default: return state;
  }
}